export { default } from './StarsRatingBar';
export { StarsRatingBarProps } from './StarsRatingBar.types';
